<capra-toast
  class="dataset-status-toast"
  [type]="type"
  [showCloseBtn]="showCloseBtn"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
	<div class="dataset-status-toast-content">
		<div class="toast-content">
			<p class="toast-header" *ngIf="heading">{{ heading }}</p>
			<p class="toast-text" *ngIf="text">{{ text }}</p>
		</div>
		<div class="toast-ctas" *ngIf="cta">
			<capra-button-link
			data-test="ts-data-workspace-link-cta"
			[href]="ctaLink"
			variant="secondary"
			color="neutral"
			size="small"
			[text]="cta"
			icon="icon-new-tab"
			iconLocation="right"
			></capra-button-link>
		</div>
	</div>
</capra-toast>